export const parseDateValue = value => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const parseGoogleReviewDate = value => {
  if (!value || typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  const [datePart, timePart] = trimmed.split(/\s+/);
  if (!datePart) {
    return parseDateValue(trimmed);
  }

  const [monthStr, dayStr, yearStr] = datePart.split('/');
  const month = Number(monthStr);
  const day = Number(dayStr);
  const year = Number(yearStr);

  if (!month || !day || !year) {
    return parseDateValue(trimmed);
  }

  let hours = 0;
  let minutes = 0;
  let seconds = 0;
  if (timePart) {
    const [hourStr, minuteStr, secondStr] = timePart.split(':');
    hours = Number(hourStr) || 0;
    minutes = Number(minuteStr) || 0;
    seconds = Number(secondStr) || 0;
  }

  const parsed = new Date(year, month - 1, day, hours, minutes, seconds);
  return Number.isNaN(parsed.getTime()) ? parseDateValue(trimmed) : parsed;
};
